"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'form-builder' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 5 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'form-builder' });
    }
    ;
    /**
    * @typedef {Object} formBuilderManageChoicesDuplicateChoiceClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} choice_name - choice_name
    * @property {GUID} esi - esi
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder -  Manage Choices - Duplicate Choice - click. Evid: 877.
     * Event description: user click on duplicate choice.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * choice_name - Type: string. Desc: choice_name
     *
     * esi - Type: guid. Desc: esi
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageChoicesDuplicateChoiceClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageChoicesDuplicateChoiceClick = function (params) {
        return this.bi.log(__assign({ evid: 877 }, params));
    };
    /**
    * @typedef {Object} formBuilderAdiReorderFieldClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} field_name - field_name
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - {'dropdown', 'edit button'}
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - ADI - Reorder Field - click. Evid: 943.
     * Event description: Reorder Field - click.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * field_name - Type: string. Desc: field_name
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: {'dropdown', 'edit button'}
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderAdiReorderFieldClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderAdiReorderFieldClick = function (params) {
        return this.bi.log(__assign({ evid: 943 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSaveAndRefreshPopUpUserSelectionParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} selection - = 'dismiss' / 'question sign'/'cancel'/'save & refresh'
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form - 'save and refresh' pop up - user selection. Evid: 978.
     * Event description: Payment Form - 'save and refresh' pop up - user selection.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * selection - Type: string. Desc: = 'dismiss' / 'question sign'/'cancel'/'save & refresh'
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSaveAndRefreshPopUpUserSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSaveAndRefreshPopUpUserSelection = function (params) {
        return this.bi.log(__assign({ evid: 978 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormIfFilledSelectionOptionParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} choose - choose
    * @property {number} count - count how many fields were choosen
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - IF - filled selection option. Evid: 1101.
     * Event description: Form Builder - conditional form - IF - filled selection option.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * choose - Type: string. Desc: choose
     *
     * count - Type: numeric. Desc: count how many fields were choosen
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormIfFilledSelectionOptionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormIfFilledSelectionOption = function (params) {
        return this.bi.log(__assign({ evid: 1101 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormLearnMoreParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} origin - origin
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - learn more. Evid: 1097.
     * Event description: Form Builder - conditional form - learn more.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormLearnMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormLearnMore = function (params) {
        return this.bi.log(__assign({ evid: 1097 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepUouClickOnBackNextSubmitParams
    * @property {string} action - next/back/submit
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} step_name - step_name
    * @property {number} step_no - step_no
    * @property {number} total_number_of_steps - total_number_of_steps
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - uou click on back/next/submit. Evid: 892.
     * Event description: Form Builder - Multi Step - uou click on back/next/submit.
    
     * action - Type: string. Desc: next/back/submit
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * step_name - Type: string. Desc: step_name
     *
     * step_no - Type: numeric. Desc: step_no
     *
     * total_number_of_steps - Type: numeric. Desc: total_number_of_steps
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepUouClickOnBackNextSubmitParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepUouClickOnBackNextSubmit = function (params) {
        return this.bi.log(__assign({ evid: 892 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSubscriberDoubleOptInParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Subscriber double opt in. Evid: 1018.
     * Event description: Form Builder - Form settings - Subscriber double opt in.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSubscriberDoubleOptInParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSubscriberDoubleOptIn = function (params) {
        return this.bi.log(__assign({ evid: 1018 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageFieldsAddNewFieldCompletedParams
    * @property {string} appVersion - appVersion
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} field_group - field group (e.g recommended, my custom, custom)
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} plugin - form type = {'form-builder'/'get-subscribers'/'registration-form'}
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Manage fields - add new field completed. Evid: 903.
     * Event description: new field has been added to the form.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * field_group - Type: string. Desc: field group (e.g recommended, my custom, custom)
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * plugin - Type: string. Desc: form type = {'form-builder'/'get-subscribers'/'registration-form'}
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageFieldsAddNewFieldCompletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageFieldsAddNewFieldCompleted = function (params) {
        return this.bi.log(__assign({ evid: 903 }, params));
    };
    /**
    * @typedef {Object} formBuilderTooltipForAddFieldForbiddenWordsParams
    * @property {string} entered_text - entered_text
    * @property {GUID} esi - esi
    * @property {string} field_name - field_name
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - tooltip for add field forbidden words. Evid: 870.
     * Event description: a tooltip with message is presented due to  forbidden field name.
    
     * entered_text - Type: string. Desc: entered_text
     *
     * esi - Type: guid. Desc: esi
     *
     * field_name - Type: string. Desc: field_name
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderTooltipForAddFieldForbiddenWordsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderTooltipForAddFieldForbiddenWords = function (params) {
        return this.bi.log(__assign({ evid: 870 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSetupAddUpdateItemParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {string} item_name - item_name
    * @property {number} item_price - item_price
    * @property {GUID} msid - msid
    * @property {string} type - 'add' / 'update'
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form Setup - add/update item. Evid: 972.
     * Event description: Payment Form Setup - add/update item.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * item_name - Type: string. Desc: item_name
     *
     * item_price - Type: numeric. Desc: item_price
     *
     * msid - Type: guid. Desc: msid
     *
     * type - Type: string. Desc: 'add' / 'update'
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSetupAddUpdateItemParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSetupAddUpdateItem = function (params) {
        return this.bi.log(__assign({ evid: 972 }, params));
    };
    /**
    * @typedef {Object} formBuilderCaptachaStatusParams
    * @property {string} authentication_status - { 'verified' / 'expire' / 'reset'}
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Form Builder - captacha status. Evid: 869.
     * Event description: Form submission - captcha status.
    
     * authentication_status - Type: string. Desc: { 'verified' / 'expire' / 'reset'}
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {formBuilderCaptachaStatusParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderCaptachaStatus = function (params) {
        return this.bi.log(__assign({ evid: 869 }, params));
    };
    /**
    * @typedef {Object} formBuilderSubmitButtonUploadFileClickParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Submit Button- Upload file click. Evid: 938.
     * Event description: user clicks on upload file in form settings.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderSubmitButtonUploadFileClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderSubmitButtonUploadFileClick = function (params) {
        return this.bi.log(__assign({ evid: 938 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSettingsTabsClickParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} name - 'Email Notifications', 'Submission Table', 'Contact Labels'
    * @property {string} source - null
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - settings tabs - click. Evid: 954.
     * Event description: Form Builder - Form settings - settings tabs - click.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: 'Email Notifications', 'Submission Table', 'Contact Labels'
     *
     * source - Type: string.
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSettingsTabsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSettingsTabsClick = function (params) {
        return this.bi.log(__assign({ evid: 954 }, params));
    };
    /**
    * @typedef {Object} formBuilderUserSaveAnEditorTemplateWithFormParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - Form template selected
    * @property {GUID} templateId - editor template guid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - User save an editor template with form. Evid: 936.
     * Event description: user saving an editor template with embedded wix form.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: Form template selected
     *
     * templateId - Type: guid. Desc: editor template guid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderUserSaveAnEditorTemplateWithFormParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderUserSaveAnEditorTemplateWithForm = function (params) {
        return this.bi.log(__assign({ evid: 936 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSubmitMessageRestoreSuccessMessageParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} field_name - field_name
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Submit Message - Restore Field. Evid: 966.
     * Event description: Submit Message - Restore field.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * field_name - Type: string. Desc: field_name
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSubmitMessageRestoreSuccessMessageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSubmitMessageRestoreSuccessMessage = function (params) {
        return this.bi.log(__assign({ evid: 966 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsInnerTabsClickParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} source - source
    * @property {string} tab_name - main/settings/ submit message / automations / support / upgrade / contact list
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - inner tabs - click. Evid: 953.
     * Event description: Form Builder - Form settings - inner tabs - click.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * source - Type: string. Desc: source
     *
     * tab_name - Type: string. Desc: main/settings/ submit message / automations / support / upgrade / contact list
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsInnerTabsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsInnerTabsClick = function (params) {
        return this.bi.log(__assign({ evid: 953 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSubscriberDoubleOptInEnableParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {boolean} toggle - true for on, false for off
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Subscriber double opt in - Enable. Evid: 1020.
     * Event description: Form Builder - Form settings - Subscriber double opt in - Enable.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * toggle - Type: bool. Desc: true for on, false for off
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSubscriberDoubleOptInEnableParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSubscriberDoubleOptInEnable = function (params) {
        return this.bi.log(__assign({ evid: 1020 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepClickOnEditStepParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} step_name - step_name
    * @property {number} step_no - step_no
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - click on edit step. Evid: 884.
     * Event description: Form Builder - Multi Step - click on edit step.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * step_name - Type: string. Desc: step_name
     *
     * step_no - Type: numeric. Desc: step_no
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepClickOnEditStepParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepClickOnEditStep = function (params) {
        return this.bi.log(__assign({ evid: 884 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepTipPresentedParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - tip presented. Evid: 880.
     * Event description: Form Builder - Multi Step - tip presented.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepTipPresentedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepTipPresented = function (params) {
        return this.bi.log(__assign({ evid: 880 }, params));
    };
    /**
    * @typedef {Object} formBuilderPresetGlobalDesignFailedParams
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} name - preset or global design
    * @property {string} reason - fail reason
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Preset / Global design failed. Evid: 939.
     * Event description: user couldn't install a preset or change global design.
    
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: preset or global design
     *
     * reason - Type: string. Desc: fail reason
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPresetGlobalDesignFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPresetGlobalDesignFailed = function (params) {
        return this.bi.log(__assign({ evid: 939 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormIfClickOnDropdownParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - null
    * @property {GUID} msid - msid
    * @property {string} template - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - IF - click on dropdown. Evid: 1098.
    
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string.
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormIfClickOnDropdownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormIfClickOnDropdown = function (params) {
        return this.bi.log(__assign({ evid: 1098 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormLayoutOpenAndChangeParams
    * @property {string} action - open,select
    * @property {string} builderOrigin - ADI/Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {string} layout - new layout: single, 2 column, 3 column
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form layout - open and change. Evid: 924.
     * Event description: form layout panel is opened (action=open)
    user clicks on a new layout (action=select).
    
     * action - Type: string. Desc: open,select
     *
     * builderOrigin - Type: string. Desc: ADI/Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * layout - Type: string. Desc: new layout: single, 2 column, 3 column
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormLayoutOpenAndChangeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormLayoutOpenAndChange = function (params) {
        return this.bi.log(__assign({ evid: 924 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsNotificationsHelpClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - notifications help click. Evid: 990.
     * Event description: user click on the "?" in the bottom of notifications tab (under the form settings).
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsNotificationsHelpClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsNotificationsHelpClick = function (params) {
        return this.bi.log(__assign({ evid: 990 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepClickOnRestoreButtonsParams
    * @property {string} action - ‘restore back button’/ ‘restore next button’/‘restore submit button’
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder  - click on restore buttons. Evid: 894.
     * Event description: Form Builder - click on restore next/back/submit buttons.
    
     * action - Type: string. Desc: ‘restore back button’/ ‘restore next button’/‘restore submit button’
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepClickOnRestoreButtonsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepClickOnRestoreButtons = function (params) {
        return this.bi.log(__assign({ evid: 894 }, params));
    };
    /**
    * @typedef {Object} formBuilderMigratedFormContactFormToWixFormSuccessParams
    * @property {string} form_comp_id - form comp id
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - migrated form contact form to wix form success. Evid: 1095.
     * Event description: Form Builder - Editor X - add a subscribe checkbox.
    
     * form_comp_id - Type: string. Desc: form comp id
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMigratedFormContactFormToWixFormSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMigratedFormContactFormToWixFormSuccess = function (params) {
        return this.bi.log(__assign({ evid: 1095 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormCopyAttemptFailedParams
    * @property {GUID} esi - esi
    * @property {string} failReason - fail reason
    * @property {string} form_comp_id - id of original form
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form copy attempt failed. Evid: 937.
     * Event description: copy of a form failed.
    
     * esi - Type: guid. Desc: esi
     *
     * failReason - Type: string. Desc: fail reason
     *
     * form_comp_id - Type: string. Desc: id of original form
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormCopyAttemptFailedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormCopyAttemptFailed = function (params) {
        return this.bi.log(__assign({ evid: 937 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageChoicesUpdateChoiceNameParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder -  Manage Choices - update choice name. Evid: 875.
     * Event description: user updating choice name.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageChoicesUpdateChoiceNameParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageChoicesUpdateChoiceName = function (params) {
        return this.bi.log(__assign({ evid: 875 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormContradictingRuleWarningParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - contradicting rule warning. Evid: 1109.
     * Event description: Form Builder - conditional form - contradicting rule warning.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormContradictingRuleWarningParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormContradictingRuleWarning = function (params) {
        return this.bi.log(__assign({ evid: 1109 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormMoreActionChooseParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} choose - which option the user chooses
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - more action - choose. Evid: 1108.
     * Event description: Form Builder - conditional form - more action - choose.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * choose - Type: string. Desc: which option the user chooses
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormMoreActionChooseParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormMoreActionChoose = function (params) {
        return this.bi.log(__assign({ evid: 1108 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageFieldsAddNewFieldParams
    * @property {string} appVersion - appVersion
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} field_group - field group (e.g recommended, my custom, custom)
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} plugin - form type = {'form-builder'/'get-subscribers'/'registration-form'}
    * @property {string} tabName - tab name
    * @property {string} template - template name
    * @property {GUID} visitor_id - deprecated
    **/
    /**
     * Name: Form Builder - Manage fields - add new field. Evid: 916.
     * Event description: users selects a new field to be added to the form.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * field_group - Type: string. Desc: field group (e.g recommended, my custom, custom)
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * plugin - Type: string. Desc: form type = {'form-builder'/'get-subscribers'/'registration-form'}
     *
     * tabName - Type: string. Desc: tab name
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: deprecated
     * @param {formBuilderManageFieldsAddNewFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageFieldsAddNewField = function (params) {
        return this.bi.log(__assign({ evid: 916 }, params));
    };
    /**
    * @typedef {Object} formBuilderAdiEditFormCompletedParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - {'dropdown', 'edit button'}
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - ADI - Edit Form panel opened- completed. Evid: 942.
     * Event description: Edit form - completed.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: {'dropdown', 'edit button'}
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderAdiEditFormCompletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderAdiEditFormCompleted = function (params) {
        return this.bi.log(__assign({ evid: 942 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSetupConnectPaymentMethodParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form Setup - Connect Payment Method. Evid: 974.
     * Event description: Payment Form Setup -  Connect Payment Method.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSetupConnectPaymentMethodParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSetupConnectPaymentMethod = function (params) {
        return this.bi.log(__assign({ evid: 974 }, params));
    };
    /**
    * @typedef {Object} formBuilderCategoryPickerInAddPanelParams
    * @property {string} builderOrigin - ADI  /  Editor
    * @property {string} category - 'Contact' / 'Payment Form' / 'Job Application' / etc...
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - category picker in add panel. Evid: 987.
     * Event description: user click on one of Wix forms category in contact tab in add panel..
    
     * builderOrigin - Type: string. Desc: ADI  /  Editor
     *
     * category - Type: string. Desc: 'Contact' / 'Payment Form' / 'Job Application' / etc...
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderCategoryPickerInAddPanelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderCategoryPickerInAddPanel = function (params) {
        return this.bi.log(__assign({ evid: 987 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepHoverOnInfoIconOfRestoreButtonsParams
    * @property {string} action - ‘restore back button’/ ‘restore next button’/‘restore submit button’
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder -  hover on info icon of restore buttons. Evid: 893.
     * Event description: Form Builder - hover on info icon of restore next/back/submit buttons.
    
     * action - Type: string. Desc: ‘restore back button’/ ‘restore next button’/‘restore submit button’
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepHoverOnInfoIconOfRestoreButtonsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepHoverOnInfoIconOfRestoreButtons = function (params) {
        return this.bi.log(__assign({ evid: 893 }, params));
    };
    /**
    * @typedef {Object} copyOfFormBuilderSubmissionSettingsButtonClickParams
    * @property {string} builderOrigin - 'ADI'/ 'Editor'
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Copy of Form Builder - submission settings button - click. Evid: 899.
     * Event description: submission settings button - click.
    
     * builderOrigin - Type: string. Desc: 'ADI'/ 'Editor'
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {copyOfFormBuilderSubmissionSettingsButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.copyOfFormBuilderSubmissionSettingsButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 899 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsUpdateValueParams
    * @property {string} action_type - 'save','cancel'
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} name - form name, email,second email, success message, error message,label
    * @property {string} origin - 'submissions','notifications'
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - update value. Evid: 923.
     * Event description: user updates a value in form settings.
    
     * action_type - Type: string. Desc: 'save','cancel'
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: form name, email,second email, success message, error message,label
     *
     * origin - Type: string. Desc: 'submissions','notifications'
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsUpdateValueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsUpdateValue = function (params) {
        return this.bi.log(__assign({ evid: 923 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormClickOnNextInPaymentFormSetupParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} direction - 'back' / 'next'
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {string} move_to_step - = 'add item' , 'connect payment' , 'upgrade', 'continue without accepting payment', 'done'
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form - click on ‘next’ in Payment Form Setup. Evid: 984.
     * Event description: user click on ‘next’ in Payment Form Setup.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * direction - Type: string. Desc: 'back' / 'next'
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * move_to_step - Type: string. Desc: = 'add item' , 'connect payment' , 'upgrade', 'continue without accepting payment', 'done'
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormClickOnNextInPaymentFormSetupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormClickOnNextInPaymentFormSetup = function (params) {
        return this.bi.log(__assign({ evid: 984 }, params));
    };
    /**
    * @typedef {Object} formBuilderAdiEditFormClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - {'dropdown', 'edit button'}
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - ADI - Edit Form - Click. Evid: 941.
     * Event description: User click on edit form in ADI.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: {'dropdown', 'edit button'}
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderAdiEditFormClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderAdiEditFormClick = function (params) {
        return this.bi.log(__assign({ evid: 941 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormLayoutSpaceBetweenFieldTitleAndInputParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {string} value - value of  Space between field title and input
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form layout - Space between field title and input. Evid: 950.
     * Event description: user updated value of  Space between field title and input.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * value - Type: string. Desc: value of  Space between field title and input
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormLayoutSpaceBetweenFieldTitleAndInputParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormLayoutSpaceBetweenFieldTitleAndInput = function (params) {
        return this.bi.log(__assign({ evid: 950 }, params));
    };
    /**
    * @typedef {Object} formBuilderGetSubscribersFormManageSubscribersActionsClickParams
    * @property {string} action - 'Create Email'/'Get Started'/'Manage Your Contacts'
    * @property {GUID} esi - esi
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - GetSubscribers Form- Manage Subscribers - Actions Click. Evid: 868.
     * Event description: user click actions in Manage Subscribers pop-up in GetSubscribers Form.
    
     * action - Type: string. Desc: 'Create Email'/'Get Started'/'Manage Your Contacts'
     *
     * esi - Type: guid. Desc: esi
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderGetSubscribersFormManageSubscribersActionsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderGetSubscribersFormManageSubscribersActionsClick = function (params) {
        return this.bi.log(__assign({ evid: 868 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsInboxOptInOutWhoToNotifyParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} choose - 'contributers','other'
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - inbox opt in/out - who to notify. Evid: 1022.
     * Event description: Form Builder - Form settings - inbox opt in/out - who to notify.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * choose - Type: string. Desc: 'contributers','other'
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsInboxOptInOutWhoToNotifyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsInboxOptInOutWhoToNotify = function (params) {
        return this.bi.log(__assign({ evid: 1022 }, params));
    };
    /**
    * @typedef {Object} formBuildrComponentLoadTimeParams
    * @property {string} appVersion - appVersion
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {number} loadingTime - loading time (milliseconds)
    * @property {GUID} msid - msid
    * @property {string} panel_name - panel name
    * @property {string} template - form template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Buildr - Component load time. Evid: 907.
     * Event description: Loading time for uou.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * loadingTime - Type: numeric. Desc: loading time (milliseconds)
     *
     * msid - Type: guid. Desc: msid
     *
     * panel_name - Type: string. Desc: panel name
     *
     * template - Type: string. Desc: form template
     *
     * visitor_id - Type: guid.
     * @param {formBuildrComponentLoadTimeParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuildrComponentLoadTime = function (params) {
        return this.bi.log(__assign({ evid: 907 }, params));
    };
    /**
    * @typedef {Object} formBuilderDeleteFormParams
    * @property {string} appVersion - appVersion
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Delete form. Evid: 908.
     * Event description: user remove a form.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderDeleteFormParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderDeleteForm = function (params) {
        return this.bi.log(__assign({ evid: 908 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsUpdateValueClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} name - deprecated
    * @property {string} origin - 'notifications', 'submissions'
    * @property {string} selection - 'save','cancel'
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - update value click. Evid: 991.
     * Event description: user click to updates a value in form settings after popup of updating name appears and choose 'save' or 'cancel'.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: deprecated
     *
     * origin - Type: string. Desc: 'notifications', 'submissions'
     *
     * selection - Type: string. Desc: 'save','cancel'
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsUpdateValueClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsUpdateValueClick = function (params) {
        return this.bi.log(__assign({ evid: 991 }, params));
    };
    /**
    * @typedef {Object} formBuilderPremiumPanelClickParams
    * @property {string} current_ascend_plan - plan name (Basic/Pro/..)  or ‘free’
    * @property {GUID} esi - esi
    * @property {GUID} msid - msid
    * @property {string} origin - origin
    * @property {string} selection - later/upgrade
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Premium Panel Click. Evid: 935.
     * Event description: user click in premium panel.
    
     * current_ascend_plan - Type: string. Desc: plan name (Basic/Pro/..)  or ‘free’
     *
     * esi - Type: guid. Desc: esi
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * selection - Type: string. Desc: later/upgrade
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPremiumPanelClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPremiumPanelClick = function (params) {
        return this.bi.log(__assign({ evid: 935 }, params));
    };
    /**
    * @typedef {Object} formBuilderGetSubscribersFormManageSubscribersClickParams
    * @property {string} action - Manage Subscribers
    * @property {GUID} esi - esi
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - GetSubscribers Form- Manage Subscribers Click. Evid: 867.
     * Event description: user click Manage Subscribers in GetSubscribers Form.
    
     * action - Type: string. Desc: Manage Subscribers
     *
     * esi - Type: guid. Desc: esi
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderGetSubscribersFormManageSubscribersClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderGetSubscribersFormManageSubscribersClick = function (params) {
        return this.bi.log(__assign({ evid: 867 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListChooseSavedFieldsUpdateValueParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} field - field name
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - the place where it was clicked
    * @property {string} template - template name
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: Form Builder - Form settings - contact list - choose saved fields - update value. Evid: 995.
     * Event description: Form Builder - Form settings - contact list - choose saved fields - update value.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * field - Type: string. Desc: field name
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: the place where it was clicked
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {formBuilderFormSettingsContactListChooseSavedFieldsUpdateValueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListChooseSavedFieldsUpdateValue = function (params) {
        return this.bi.log(__assign({ evid: 995 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageChoicesDeleteChoiceParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder -  Manage Choices- Delete Choice. Evid: 874.
     * Event description: Manage Choices- Delete Choice.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageChoicesDeleteChoiceParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageChoicesDeleteChoice = function (params) {
        return this.bi.log(__assign({ evid: 874 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageChoicesEditChoiceParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Manage Choices -Edit Choice. Evid: 873.
     * Event description: Manage Choices -Edit Choice.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageChoicesEditChoiceParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageChoicesEditChoice = function (params) {
        return this.bi.log(__assign({ evid: 873 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormRemovePaymentPopUpUserSelectionParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} selection - ='dismiss' / 'question sign'/ ‘remove'/ 'cancel'
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form -‘Remove Payment’ pop up - user selection. Evid: 982.
     * Event description: - Payment Form -‘Remove Payment’ pop up - user selection.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * selection - Type: string. Desc: ='dismiss' / 'question sign'/ ‘remove'/ 'cancel'
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormRemovePaymentPopUpUserSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormRemovePaymentPopUpUserSelection = function (params) {
        return this.bi.log(__assign({ evid: 982 }, params));
    };
    /**
    * @typedef {Object} formBuilderEditFieldPanelOpenedParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - panel opened from (gfpp,manage fields...)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Edit field - panel opened. Evid: 917.
     * Event description: edit field panel is opened.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: panel opened from (gfpp,manage fields...)
     *
     * visitor_id - Type: guid.
     * @param {formBuilderEditFieldPanelOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderEditFieldPanelOpened = function (params) {
        return this.bi.log(__assign({ evid: 917 }, params));
    };
    /**
    * @typedef {Object} formBuilderEditFieldConnectFieldParams
    * @property {string} builderOrigin - ADI/Editor
    * @property {string} connected_field - name of CRM field connected to
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} plugin - plugin
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Edit field - connect field. Evid: 921.
     * Event description: user selects a field to connect to.
    
     * builderOrigin - Type: string. Desc: ADI/Editor
     *
     * connected_field - Type: string. Desc: name of CRM field connected to
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * plugin - Type: string. Desc: plugin
     *
     * visitor_id - Type: guid.
     * @param {formBuilderEditFieldConnectFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderEditFieldConnectField = function (params) {
        return this.bi.log(__assign({ evid: 921 }, params));
    };
    /**
    * @typedef {Object} formBuilderBizMgrViewFormSubmissionsClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - 'main tab' , 'settings tab'
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Biz Mgr - view form submissions - click. Evid: 931.
     * Event description: user clicks on view form submissions inside forms BO.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: 'main tab' , 'settings tab'
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderBizMgrViewFormSubmissionsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderBizMgrViewFormSubmissionsClick = function (params) {
        return this.bi.log(__assign({ evid: 931 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsPanelOpenedParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - panel opened. Evid: 922.
     * Event description: form settings panel is opened.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsPanelOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsPanelOpened = function (params) {
        return this.bi.log(__assign({ evid: 922 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsInboxOptInOutLearnMoreParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} current_option - contributors/others
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - inbox opt in/out - learn more. Evid: 1024.
     * Event description: Form Builder - Form settings - update email.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * current_option - Type: string. Desc: contributors/others
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsInboxOptInOutLearnMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsInboxOptInOutLearnMore = function (params) {
        return this.bi.log(__assign({ evid: 1024 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSubmitMessageChooseLinkClickParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {string} link_type - 'link to page or lightbox' / 'link to external URL'
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Submit Message - Choose Link - click. Evid: 965.
     * Event description: Submit Message - Choose Link - click.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * link_type - Type: string. Desc: 'link to page or lightbox' / 'link to external URL'
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSubmitMessageChooseLinkClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSubmitMessageChooseLinkClick = function (params) {
        return this.bi.log(__assign({ evid: 965 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepCloseDonTShowTipParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} click_type - 'dismiss'/ 'don't show again'
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - close/ don't show tip. Evid: 881.
     * Event description: Form Builder - Multi Step - close/ don't show tip.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * click_type - Type: string. Desc: 'dismiss'/ 'don't show again'
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepCloseDonTShowTipParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepCloseDonTShowTip = function (params) {
        return this.bi.log(__assign({ evid: 881 }, params));
    };
    /**
    * @typedef {Object} formBuilderSubmissionSettingsPanelOpenedParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Form Builder - Submission settings - panel opened. Evid: 986.
     * Event description: Submission settings - panel opened.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {formBuilderSubmissionSettingsPanelOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderSubmissionSettingsPanelOpened = function (params) {
        return this.bi.log(__assign({ evid: 986 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSupportAddAReviewClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Support - Add a Review - click. Evid: 960.
     * Event description: Form Builder - Form settings - Support - Add a Review - click.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSupportAddAReviewClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSupportAddAReviewClick = function (params) {
        return this.bi.log(__assign({ evid: 960 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSetupItemPriceChangeCurrencyParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form Setup - item price - Change currency. Evid: 973.
     * Event description: Payment Form Setup -  item price - Change currency - click.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSetupItemPriceChangeCurrencyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSetupItemPriceChangeCurrency = function (params) {
        return this.bi.log(__assign({ evid: 973 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSupportWixSupportClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Support - Wix Support - click. Evid: 958.
     * Event description: Form Builder - Form settings - Support - Wix Support - click.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSupportWixSupportClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSupportWixSupportClick = function (params) {
        return this.bi.log(__assign({ evid: 958 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsMsgLinkParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} selection - open link/message
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - msg/link. Evid: 926.
     * Event description: user select message or open link.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * selection - Type: string. Desc: open link/message
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsMsgLinkParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsMsgLink = function (params) {
        return this.bi.log(__assign({ evid: 926 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSettingGetStartedParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form Setting - Get Started. Evid: 968.
     * Event description: user click on  Get Started in Payment Form settings.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSettingGetStartedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSettingGetStarted = function (params) {
        return this.bi.log(__assign({ evid: 968 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormSaveRuleErrorParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - null
    * @property {GUID} msid - msid
    * @property {string} template - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - save rule error. Evid: 1110.
    
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string.
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormSaveRuleErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormSaveRuleError = function (params) {
        return this.bi.log(__assign({ evid: 1110 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageChoicesUpdateDisplayNameParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Manage Choices - update display name. Evid: 871.
     * Event description: When user is updating the field name (displayed question) in 'Manage Choices' Settings Pop up.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageChoicesUpdateDisplayNameParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageChoicesUpdateDisplayName = function (params) {
        return this.bi.log(__assign({ evid: 871 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListChooseSavedFieldsClickParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: Form Builder - Form settings - contact list - choose saved fields - click. Evid: 994.
     * Event description: Form Builder - Form settings - contact list - choose saved fields - click.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {formBuilderFormSettingsContactListChooseSavedFieldsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListChooseSavedFieldsClick = function (params) {
        return this.bi.log(__assign({ evid: 994 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormLayoutTitleAndPlaceholderPaddingParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {string} value - value of Input Text Padding
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form layout - Input Text Padding. Evid: 949.
     * Event description: user updated value of Input Text Padding.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * value - Type: string. Desc: value of Input Text Padding
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormLayoutTitleAndPlaceholderPaddingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormLayoutTitleAndPlaceholderPadding = function (params) {
        return this.bi.log(__assign({ evid: 949 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListChooseSavedFieldsHoverFieldsInContactListParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - contact list - choose saved fields - hover fields in contact list. Evid: 1011.
     * Event description: Copy of Form Builder - Form settings - contact list - choose saved fields - hover fields in contact list.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsContactListChooseSavedFieldsHoverFieldsInContactListParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListChooseSavedFieldsHoverFieldsInContactList = function (params) {
        return this.bi.log(__assign({ evid: 1011 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormIsClickOnDropdownParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - IS - click on dropdown. Evid: 1104.
     * Event description: Form Builder - conditional form - IS - click on dropdown.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormIsClickOnDropdownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormIsClickOnDropdown = function (params) {
        return this.bi.log(__assign({ evid: 1104 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepClickOnAscendPlanParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - Click on Ascend Plan. Evid: 889.
     * Event description: Form Builder - Multi Step - Click on Ascend Plan.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepClickOnAscendPlanParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepClickOnAscendPlan = function (params) {
        return this.bi.log(__assign({ evid: 889 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsEmailNotificationAddContributerParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - email notification - add contributer. Evid: 1027.
     * Event description: Form Builder - Form settings - inbox opt in/out - find out more.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsEmailNotificationAddContributerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsEmailNotificationAddContributer = function (params) {
        return this.bi.log(__assign({ evid: 1027 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepDragStepParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {number} from_step - from_step location
    * @property {GUID} msid - msid
    * @property {string} step_name - step_name
    * @property {number} to_step - to_step location
    * @property {number} total_number_of_steps - total_number_of_steps
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - drag step. Evid: 882.
     * Event description: Form Builder - Multi Step - drag step.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * from_step - Type: numeric. Desc: from_step location
     *
     * msid - Type: guid. Desc: msid
     *
     * step_name - Type: string. Desc: step_name
     *
     * to_step - Type: numeric. Desc: to_step location
     *
     * total_number_of_steps - Type: numeric. Desc: total_number_of_steps
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepDragStepParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepDragStep = function (params) {
        return this.bi.log(__assign({ evid: 882 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsErrorPageTryAgainClickParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} tabName - 'contact labels','email notification'
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - error page - try again click. Evid: 1016.
     * Event description: Form Builder - Form settings - error page - try again click.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * tabName - Type: string. Desc: 'contact labels','email notification'
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsErrorPageTryAgainClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsErrorPageTryAgainClick = function (params) {
        return this.bi.log(__assign({ evid: 1016 }, params));
    };
    /**
    * @typedef {Object} formBuilderTemplatePickerChooseTemplateStartToInstallParams
    * @property {string} appVersion - appVersion
    * @property {string} builderOrigin - ADI/Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} source_name - app market / add panel /ADI/ copy form/..
    * @property {string} template - template selected
    * @property {GUID} visitor_id - deprecated
    **/
    /**
     * Name: Form Builder - Template picker - choose template - start to install. Evid: 989.
     * Event description: start to install Wixfrom.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * builderOrigin - Type: string. Desc: ADI/Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * source_name - Type: string. Desc: app market / add panel /ADI/ copy form/..
     *
     * template - Type: string. Desc: template selected
     *
     * visitor_id - Type: guid. Desc: deprecated
     * @param {formBuilderTemplatePickerChooseTemplateStartToInstallParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderTemplatePickerChooseTemplateStartToInstall = function (params) {
        return this.bi.log(__assign({ evid: 989 }, params));
    };
    /**
    * @typedef {Object} formBuilderClickOnGfppOfConnectPanelParams
    * @property {string} field_group - field group (e.g recommended, my custom, custom)
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Click on gfpp of connect panel. Evid: 945.
     * Event description: users click on gfpp of connect panel (after clicking on a single field).
    
     * field_group - Type: string. Desc: field group (e.g recommended, my custom, custom)
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderClickOnGfppOfConnectPanelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderClickOnGfppOfConnectPanel = function (params) {
        return this.bi.log(__assign({ evid: 945 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormIfChooseFromDropdownParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} fieldName - fieldName
    * @property {string} fieldType - fieldType
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - IF - choose from dropdown. Evid: 1099.
     * Event description: Copy of Form Builder - conditional form - IF - choose from dropdown.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * fieldName - Type: string. Desc: fieldName
     *
     * fieldType - Type: string. Desc: fieldType
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormIfChooseFromDropdownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormIfChooseFromDropdown = function (params) {
        return this.bi.log(__assign({ evid: 1099 }, params));
    };
    /**
    * @typedef {Object} formBuilderMigratedFormContactFormToWixFormPhoneNumberIssueParams
    * @property {string} form_comp_id - form comp id
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - migrated form contact form to wix form phone number issue. Evid: 1111.
     * Event description: Form Builder - migrated form contact form to wix form phone number issue.
    
     * form_comp_id - Type: string. Desc: form comp id
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMigratedFormContactFormToWixFormPhoneNumberIssueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMigratedFormContactFormToWixFormPhoneNumberIssue = function (params) {
        return this.bi.log(__assign({ evid: 1111 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSetupChangePaymentMethodParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form Setup - Change Payment Method. Evid: 976.
     * Event description: Payment Form Setup - Change Payment Method.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSetupChangePaymentMethodParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSetupChangePaymentMethod = function (params) {
        return this.bi.log(__assign({ evid: 976 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListChooseSavedFieldsCancelParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - contact list - choose saved fields - Cancel. Evid: 998.
     * Event description: Form Builder - Form settings - contact list - choose saved fields - Cancel.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsContactListChooseSavedFieldsCancelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListChooseSavedFieldsCancel = function (params) {
        return this.bi.log(__assign({ evid: 998 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSubscriberDoubleOptInSubmitMessageParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Subscriber double opt in - submit message. Evid: 1021.
     * Event description: Form Builder - Form settings - Subscriber double opt in - submit message.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSubscriberDoubleOptInSubmitMessageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSubscriberDoubleOptInSubmitMessage = function (params) {
        return this.bi.log(__assign({ evid: 1021 }, params));
    };
    /**
    * @typedef {Object} formBuilderSubmissionSettingsButtonClickParams
    * @property {string} builderOrigin - 'ADI'/ 'Editor'
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Form Builder - submission settings button - click. Evid: 898.
     * Event description: submission settings button - click.
    
     * builderOrigin - Type: string. Desc: 'ADI'/ 'Editor'
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {formBuilderSubmissionSettingsButtonClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderSubmissionSettingsButtonClick = function (params) {
        return this.bi.log(__assign({ evid: 898 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormIfFilledNotFilledParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} filledOption - filledOption
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - IF - filled not filled. Evid: 1100.
     * Event description: Copy of Form Builder - conditional form - IF - choose from dropdown.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * filledOption - Type: string. Desc: filledOption
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormIfFilledNotFilledParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormIfFilledNotFilled = function (params) {
        return this.bi.log(__assign({ evid: 1100 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormThenChooseFromDropdownParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {number} count - how many fields selected
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - THEN - choose from dropdown. Evid: 1103.
     * Event description: Form Builder - conditional form - THEN - choose from dropdown.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * count - Type: numeric. Desc: how many fields selected
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormThenChooseFromDropdownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormThenChooseFromDropdown = function (params) {
        return this.bi.log(__assign({ evid: 1103 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormMoreActionClickParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - more action - click. Evid: 1107.
     * Event description: Form Builder - conditional form - more action - click.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormMoreActionClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormMoreActionClick = function (params) {
        return this.bi.log(__assign({ evid: 1107 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormIsChooseFromDropdownParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} option - which option the user choose
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - IS - choose from dropdown. Evid: 1105.
     * Event description: Form Builder - conditional form - IS - choose from dropdown.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * option - Type: string. Desc: which option the user choose
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormIsChooseFromDropdownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormIsChooseFromDropdown = function (params) {
        return this.bi.log(__assign({ evid: 1105 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsEmailNotificationWantToNotifyDonTShowThisAgainParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - origin
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - email notification - want to notify - don't show this again. Evid: 1029.
     * Event description: Form Builder - Form settings - inbox opt in/out - find out more.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsEmailNotificationWantToNotifyDonTShowThisAgainParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsEmailNotificationWantToNotifyDonTShowThisAgain = function (params) {
        return this.bi.log(__assign({ evid: 1029 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSupportAboutWixFormsClickParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Support - About Wix Forms - click. Evid: 957.
     * Event description: Form Builder - Form settings - Support - About Wix Forms - click.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSupportAboutWixFormsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSupportAboutWixFormsClick = function (params) {
        return this.bi.log(__assign({ evid: 957 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSetupGetStartedClickOnDemoSiteParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form Setup - Get Started - click on demo site. Evid: 971.
     * Event description: Payment Form Setup - Get Started - click on demo site.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSetupGetStartedClickOnDemoSiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSetupGetStartedClickOnDemoSite = function (params) {
        return this.bi.log(__assign({ evid: 971 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsInboxOptInOutAreYouSureParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {boolean} checkbox - true if check false if not
    * @property {string} choose - 'cancel','yes'
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - inbox opt in/out - are you sure. Evid: 1025.
     * Event description: Form Builder - Form settings - inbox opt in/out - are you sure.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * checkbox - Type: bool. Desc: true if check false if not
     *
     * choose - Type: string. Desc: 'cancel','yes'
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string.
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsInboxOptInOutAreYouSureParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsInboxOptInOutAreYouSure = function (params) {
        return this.bi.log(__assign({ evid: 1025 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormLayoutFieldTitlePaddingParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {string} value - value of Field Title Padding
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Form Builder - Form layout - Field Title Padding. Evid: 951.
     * Event description: user updated value of Field Title Padding.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * value - Type: string. Desc: value of Field Title Padding
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {formBuilderFormLayoutFieldTitlePaddingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormLayoutFieldTitlePadding = function (params) {
        return this.bi.log(__assign({ evid: 951 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsClickParams
    * @property {string} builderOrigin - 'ADI'/ 'Editor'
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Form Builder - Form settings - click. Evid: 897.
     * Event description: Form settings - click.
    
     * builderOrigin - Type: string. Desc: 'ADI'/ 'Editor'
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {formBuilderFormSettingsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsClick = function (params) {
        return this.bi.log(__assign({ evid: 897 }, params));
    };
    /**
    * @typedef {Object} formBuilderGlobalLayoutShowFieldTitleToggleParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {boolean} toggle_state - toggle state
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Global Layout - Show Field Title Toggle. Evid: 952.
     * Event description: user updated  'Show Field Title' Toggle.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * toggle_state - Type: bool. Desc: toggle state
     *
     * visitor_id - Type: guid.
     * @param {formBuilderGlobalLayoutShowFieldTitleToggleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderGlobalLayoutShowFieldTitleToggle = function (params) {
        return this.bi.log(__assign({ evid: 952 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepClickOnHelpIconInManageStepsParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - click on help icon in manage steps. Evid: 895.
     * Event description: Form Builder - Multi Step - click on help icon in manage steps.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepClickOnHelpIconInManageStepsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepClickOnHelpIconInManageSteps = function (params) {
        return this.bi.log(__assign({ evid: 895 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListChooseSavedFieldsLearnMoreParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - contact list - choose saved fields - learn more. Evid: 999.
     * Event description: Form Builder - Form settings - contact list - choose saved fields - learn more.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsContactListChooseSavedFieldsLearnMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListChooseSavedFieldsLearnMore = function (params) {
        return this.bi.log(__assign({ evid: 999 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormRemovePaymentPopUpDisplayedParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form -‘Remove Payment' pop up - displayed. Evid: 981.
     * Event description: - Payment Form -'Remove Payment’ pop up - displayed.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormRemovePaymentPopUpDisplayedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormRemovePaymentPopUpDisplayed = function (params) {
        return this.bi.log(__assign({ evid: 981 }, params));
    };
    /**
    * @typedef {Object} siteMembersSignupSettingsEditTextFieldClickParams
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Site Members - signup settings - edit text field - click. Evid: 865.
     * Event description: user click on edit text field.
    
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {siteMembersSignupSettingsEditTextFieldClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersSignupSettingsEditTextFieldClick = function (params) {
        return this.bi.log(__assign({ evid: 865 }, params));
    };
    /**
    * @typedef {Object} formBuildrUouSubmitFormErrorParams
    * @property {string} appVersion - appVersion
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {string} form_name - the form name, given by user
    * @property {string} form_url - form specific url
    * @property {GUID} msid - msid
    * @property {number} num_of_attachments - number of attachments, 0 if none
    * @property {string} reason - error reason
    * @property {string} reason_body - error reason body
    * @property {string} template - template
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Form Buildr - UoU submit form - error. Evid: 902.
     * Event description: UoU clicked on submit in a form created with the form builder - error message displayed.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * form_name - Type: string. Desc: the form name, given by user
     *
     * form_url - Type: string. Desc: form specific url
     *
     * msid - Type: guid. Desc: msid
     *
     * num_of_attachments - Type: numeric. Desc: number of attachments, 0 if none
     *
     * reason - Type: string. Desc: error reason
     *
     * reason_body - Type: string. Desc: error reason body
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {formBuildrUouSubmitFormErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuildrUouSubmitFormError = function (params) {
        return this.bi.log(__assign({ evid: 902 }, params));
    };
    /**
    * @typedef {Object} formBuildrUouSubmitFormClickParams
    * @property {string} appVersion - appVersion
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {string} form_name - the form name, given by user
    * @property {string} form_url - form specific url
    * @property {GUID} msid - msid
    * @property {number} num_of_attachments - number of attachments, "0" if none
    * @property {string} template - template
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Form Buildr - UoU submit form - click. Evid: 900.
     * Event description: UoU clicked on submit in a form created with the form builder.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * form_name - Type: string. Desc: the form name, given by user
     *
     * form_url - Type: string. Desc: form specific url
     *
     * msid - Type: guid. Desc: msid
     *
     * num_of_attachments - Type: numeric. Desc: number of attachments, "0" if none
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {formBuildrUouSubmitFormClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuildrUouSubmitFormClick = function (params) {
        return this.bi.log(__assign({ evid: 900 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsEmailNotificationAddNewEmailParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - email notification - add new email. Evid: 1028.
     * Event description: Form Builder - Form settings - inbox opt in/out - find out more.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsEmailNotificationAddNewEmailParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsEmailNotificationAddNewEmail = function (params) {
        return this.bi.log(__assign({ evid: 1028 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSubmitSettingsClickParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form Submit settings - click. Evid: 1014.
     * Event description: Form Builder - Form Submit settings - click.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSubmitSettingsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSubmitSettingsClick = function (params) {
        return this.bi.log(__assign({ evid: 1014 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageFieldsClickOnFieldButtonLearnAllAboutThisParams
    * @property {string} field_group - field group (e.g recommended, my custom, custom)
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} tabName - tab name
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Manage fields - click on field button 'Learn All About This'. Evid: 940.
     * Event description: users click on field button 'Learn All About This'.
    
     * field_group - Type: string. Desc: field group (e.g recommended, my custom, custom)
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * tabName - Type: string. Desc: tab name
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageFieldsClickOnFieldButtonLearnAllAboutThisParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageFieldsClickOnFieldButtonLearnAllAboutThis = function (params) {
        return this.bi.log(__assign({ evid: 940 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormViewPublishSitePopUpDisplayedParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form  Builder - Payment Form -‘View Publish Site’ pop up - displayed. Evid: 979.
     * Event description: - Payment Form -‘View Publish Site’ pop up - displayed.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormViewPublishSitePopUpDisplayedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormViewPublishSitePopUpDisplayed = function (params) {
        return this.bi.log(__assign({ evid: 979 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsDisplayErrorPageParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} tabName - 'contact labels','email notification'
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - display error page. Evid: 1015.
     * Event description: Form Builder - Form settings - display error page.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * tabName - Type: string. Desc: 'contact labels','email notification'
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsDisplayErrorPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsDisplayErrorPage = function (params) {
        return this.bi.log(__assign({ evid: 1015 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsPublishYourSitePopupPresentedParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings -Publish Your Site Popup - presented. Evid: 963.
     * Event description: Publish Your Site Popup - presented
    (after user creates submission table).
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsPublishYourSitePopupPresentedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsPublishYourSitePopupPresented = function (params) {
        return this.bi.log(__assign({ evid: 963 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageChoicesDuplicateChoiceCompleteParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} choice_name - choice_name
    * @property {GUID} esi - esi
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder -  Manage Choices - Duplicate Choice - complete. Evid: 878.
     * Event description: Manage Choices - Duplicate Choice - complete.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * choice_name - Type: string. Desc: choice_name
     *
     * esi - Type: guid. Desc: esi
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageChoicesDuplicateChoiceCompleteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageChoicesDuplicateChoiceComplete = function (params) {
        return this.bi.log(__assign({ evid: 878 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepHoverOnThankYouMessageParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - hover on thank you message. Evid: 888.
     * Event description: Form Builder - Multi Step - hover on thank you message.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepHoverOnThankYouMessageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepHoverOnThankYouMessage = function (params) {
        return this.bi.log(__assign({ evid: 888 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormAddNewFieldInnerTabsClickParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - null
    * @property {GUID} msid - msid
    * @property {string} tab_name - which field catogery whose choosen
    * @property {string} template - null
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form add new field - inner tabs - click. Evid: 1093.
     * Event description: Form Builder - Form add new field - inner tabs - click.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string.
     *
     * msid - Type: guid. Desc: msid
     *
     * tab_name - Type: string. Desc: which field catogery whose choosen
     *
     * template - Type: string.
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormAddNewFieldInnerTabsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormAddNewFieldInnerTabsClick = function (params) {
        return this.bi.log(__assign({ evid: 1093 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageChoicesReorderChoiceCompleteParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} choice_name - choice_name
    * @property {GUID} esi - esi
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Manage Choices - Reorder Choice - complete. Evid: 879.
     * Event description: choice reorder is successfully completed.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * choice_name - Type: string. Desc: choice_name
     *
     * esi - Type: guid. Desc: esi
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageChoicesReorderChoiceCompleteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageChoicesReorderChoiceComplete = function (params) {
        return this.bi.log(__assign({ evid: 879 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageFieldsDuplicateFieldParams
    * @property {string} field_group - field group (e.g recommended, my custom, custom)
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Manage fields - Duplicate Field. Evid: 932.
     * Event description: users selects duplicate from manage fields.
    
     * field_group - Type: string. Desc: field group (e.g recommended, my custom, custom)
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageFieldsDuplicateFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageFieldsDuplicateField = function (params) {
        return this.bi.log(__assign({ evid: 932 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageFieldsDeleteFieldParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Manage fields - delete field. Evid: 914.
     * Event description: users clicks on delete field in field manager.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageFieldsDeleteFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageFieldsDeleteField = function (params) {
        return this.bi.log(__assign({ evid: 914 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageChoicesAddAChoiceClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Manage Choices- Add a Choice - click. Evid: 872.
     * Event description: user click on Add A Choice in Manage Choices page.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageChoicesAddAChoiceClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageChoicesAddAChoiceClick = function (params) {
        return this.bi.log(__assign({ evid: 872 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsGoToAutomationsClickParams
    * @property {string} application_name - workflows. automations...
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - 'main tab' , 'automations tab'
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Go to application - click. Evid: 955.
     * Event description: Form Builder - Form settings - Go to application - click.
    
     * application_name - Type: string. Desc: workflows. automations...
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: 'main tab' , 'automations tab'
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsGoToAutomationsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsGoToAutomationsClick = function (params) {
        return this.bi.log(__assign({ evid: 955 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSetupIsDisplayedParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form Setup is displayed. Evid: 970.
     * Event description: Payment Form Setup is displayed.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSetupIsDisplayedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSetupIsDisplayed = function (params) {
        return this.bi.log(__assign({ evid: 970 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsChangeDurationParams
    * @property {number} duration - duration in seconds
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - change duration. Evid: 925.
     * Event description: user change duration of submit message.
    
     * duration - Type: numeric. Desc: duration in seconds
     *
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsChangeDurationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsChangeDuration = function (params) {
        return this.bi.log(__assign({ evid: 925 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormLayoutSpaceBetweenColumnsParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {string} value - space between columns value
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form layout - Space between columns. Evid: 947.
     * Event description: user updated space between columns.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * value - Type: string. Desc: space between columns value
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormLayoutSpaceBetweenColumnsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormLayoutSpaceBetweenColumns = function (params) {
        return this.bi.log(__assign({ evid: 947 }, params));
    };
    /**
    * @typedef {Object} formBuilderBizMgrAddNewFormClickParams
    * @property {GUID} msid - msid
    * @property {string} place - {top button,empty}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Biz Mgr - add new form - click. Evid: 930.
     * Event description: user clicks on add new form inside forms BO.
    
     * msid - Type: guid. Desc: msid
     *
     * place - Type: string. Desc: {top button,empty}
     *
     * visitor_id - Type: guid.
     * @param {formBuilderBizMgrAddNewFormClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderBizMgrAddNewFormClick = function (params) {
        return this.bi.log(__assign({ evid: 930 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListContactLabelsUpdateValueParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: Form Builder - Form settings - contact list - contact labels - update value. Evid: 993.
     * Event description: Copy of Form Builder - Form settings - contact list - contact labels - update value.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {formBuilderFormSettingsContactListContactLabelsUpdateValueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListContactLabelsUpdateValue = function (params) {
        return this.bi.log(__assign({ evid: 993 }, params));
    };
    /**
    * @typedef {Object} formBuildrUouSubmitFormSuccessParams
    * @property {string} appVersion - appVersion
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {string} form_name - the form name, given by user
    * @property {string} form_url - form specific url
    * @property {GUID} msid - msid
    * @property {number} num_of_attachments - number of attachments, 0 if none
    * @property {string} template - template
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Form Buildr - UoU submit form - success. Evid: 901.
     * Event description: UoU clicked on submit in a form created with the form builder - success message  displayed.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * form_name - Type: string. Desc: the form name, given by user
     *
     * form_url - Type: string. Desc: form specific url
     *
     * msid - Type: guid. Desc: msid
     *
     * num_of_attachments - Type: numeric. Desc: number of attachments, 0 if none
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {formBuildrUouSubmitFormSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuildrUouSubmitFormSuccess = function (params) {
        return this.bi.log(__assign({ evid: 901 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsPublishYourSitePopupSelectionParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} selection - 'got it'/ 'dismiss'/ 'question'
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings -Publish Your Site Popup - selection. Evid: 964.
     * Event description: user click on one of the buttons in 'Publish Your Site' pop-up.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * selection - Type: string. Desc: 'got it'/ 'dismiss'/ 'question'
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsPublishYourSitePopupSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsPublishYourSitePopupSelection = function (params) {
        return this.bi.log(__assign({ evid: 964 }, params));
    };
    /**
    * @typedef {Object} formBuilderHoverOnUpgradeAscendParams
    * @property {string} builderOrigin - ADI  /  Editor
    * @property {string} button_name - upgrade button / ascend title
    * @property {string} current_ascend_plan - plan name or ‘free’
    * @property {GUID} msid - msid
    * @property {string} tabName - BM tab name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Hover on Upgrade Ascend. Evid: 997.
     * Event description: Form Builder - Hover on Upgrade Ascend.
    
     * builderOrigin - Type: string. Desc: ADI  /  Editor
     *
     * button_name - Type: string. Desc: upgrade button / ascend title
     *
     * current_ascend_plan - Type: string. Desc: plan name or ‘free’
     *
     * msid - Type: guid. Desc: msid
     *
     * tabName - Type: string. Desc: BM tab name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderHoverOnUpgradeAscendParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderHoverOnUpgradeAscend = function (params) {
        return this.bi.log(__assign({ evid: 997 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepBackNextButtonFinishUpdateTextParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} button - next/back
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} name - name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - back/next button - finish update text. Evid: 891.
     * Event description: Form Builder - Multi Step - back/next button - finish update text.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * button - Type: string. Desc: next/back
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepBackNextButtonFinishUpdateTextParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepBackNextButtonFinishUpdateText = function (params) {
        return this.bi.log(__assign({ evid: 891 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepEditStepActionsParams
    * @property {string} action - ‘rename’/’duplicate’/’delete’/’Submit Message’
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} step_name - step_name
    * @property {number} step_no - step_no
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - edit step actions. Evid: 885.
     * Event description: Form Builder - Multi Step - edit step actions.
    
     * action - Type: string. Desc: ‘rename’/’duplicate’/’delete’/’Submit Message’
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * step_name - Type: string. Desc: step_name
     *
     * step_no - Type: numeric. Desc: step_no
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepEditStepActionsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepEditStepActions = function (params) {
        return this.bi.log(__assign({ evid: 885 }, params));
    };
    /**
    * @typedef {Object} formBuilderSubmitButtonSettingsUpdateValueOfSubmitButtonParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {string} value - name of updated value
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Form Builder - Submit Button Settings - Update Value of submit button. Evid: 1013.
     * Event description: Form Builder - Submit Button Settings - Update Value of submit button.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * value - Type: string. Desc: name of updated value
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {formBuilderSubmitButtonSettingsUpdateValueOfSubmitButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderSubmitButtonSettingsUpdateValueOfSubmitButton = function (params) {
        return this.bi.log(__assign({ evid: 1013 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageFieldsAddNewFieldDropDownOpenedParams
    * @property {string} builderOrigin - ADI/Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - deprecated
    **/
    /**
     * Name: Form Builder - Manage fields - add new field drop-down opened. Evid: 915.
     * Event description: user clicks on add new field and fields drop-down is opened.
    
     * builderOrigin - Type: string. Desc: ADI/Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: deprecated
     * @param {formBuilderManageFieldsAddNewFieldDropDownOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageFieldsAddNewFieldDropDownOpened = function (params) {
        return this.bi.log(__assign({ evid: 915 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSupportSendYourFeedbackClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Support - Send Your Feedback - click. Evid: 959.
     * Event description: Form Builder - Form settings - Support - Send Your Feedback - click.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSupportSendYourFeedbackClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSupportSendYourFeedbackClick = function (params) {
        return this.bi.log(__assign({ evid: 959 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormThenClickOnDropdownParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - THEN - click on dropdown. Evid: 1102.
     * Event description: Form Builder - conditional form - THEN - click on dropdown.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormThenClickOnDropdownParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormThenClickOnDropdown = function (params) {
        return this.bi.log(__assign({ evid: 1102 }, params));
    };
    /**
    * @typedef {Object} formBuilderRemoveSubmitButtonParams
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Remove Submit Button. Evid: 933.
     * Event description: users delete submit button.
    
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderRemoveSubmitButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderRemoveSubmitButton = function (params) {
        return this.bi.log(__assign({ evid: 933 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepAddNewFieldParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - add new field. Evid: 887.
     * Event description: Form Builder - Multi Step - add new field.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepAddNewFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepAddNewField = function (params) {
        return this.bi.log(__assign({ evid: 887 }, params));
    };
    /**
    * @typedef {Object} formBuilderEditFieldConnectFieldDropDownOpenedParams
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {number} num_of_fields - number of available fields to connect (0 if none)
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Edit field - connect field drop-down opened. Evid: 920.
     * Event description: user click on connect field and drop-down opened.
    
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * num_of_fields - Type: numeric. Desc: number of available fields to connect (0 if none)
     *
     * visitor_id - Type: guid.
     * @param {formBuilderEditFieldConnectFieldDropDownOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderEditFieldConnectFieldDropDownOpened = function (params) {
        return this.bi.log(__assign({ evid: 920 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormOpenChangeRemoveDisconnectPaymentParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} selection - 'Open Payment Overview' , 'Change Payment Method', 'Remove Payment from this site', 'Disconnect Payment from this site'
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form - open/change/remove/disconnect payment. Evid: 983.
     * Event description: Payment Form - open/change/remove/disconnect payment.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * selection - Type: string. Desc: 'Open Payment Overview' , 'Change Payment Method', 'Remove Payment from this site', 'Disconnect Payment from this site'
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormOpenChangeRemoveDisconnectPaymentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormOpenChangeRemoveDisconnectPayment = function (params) {
        return this.bi.log(__assign({ evid: 983 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsCreateSubmissionsTableSuccessParams
    * @property {string} appVersion - appVersion
    * @property {string} builderOrigin - ADI/Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} request_type - {manual (user click), auto (from template}
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - create submissions table - success. Evid: 929.
     * Event description: submissions table was created successfully.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * builderOrigin - Type: string. Desc: ADI/Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * request_type - Type: string. Desc: {manual (user click), auto (from template}
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsCreateSubmissionsTableSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsCreateSubmissionsTableSuccess = function (params) {
        return this.bi.log(__assign({ evid: 929 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsLinkSelectionParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} sub_type - page url/lightbox_id
    * @property {string} template - template name
    * @property {string} type - none/page/lightbox
    * @property {GUID} visitor_id - deprecated
    **/
    /**
     * Name: Form Builder - Form settings - link selection. Evid: 927.
     * Event description: user click done on link selection.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * sub_type - Type: string. Desc: page url/lightbox_id
     *
     * template - Type: string. Desc: template name
     *
     * type - Type: string. Desc: none/page/lightbox
     *
     * visitor_id - Type: guid. Desc: deprecated
     * @param {formBuilderFormSettingsLinkSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsLinkSelection = function (params) {
        return this.bi.log(__assign({ evid: 927 }, params));
    };
    /**
    * @typedef {Object} siteMembersSignupSettingsEditFieldIsCheckedByDefaultParams
    * @property {boolean} checked_by_default - true/false
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Site Members - signup settings - edit field-  is checked by default. Evid: 863.
     * Event description: user selects/deselects if field is checked by default.
    
     * checked_by_default - Type: bool. Desc: true/false
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {siteMembersSignupSettingsEditFieldIsCheckedByDefaultParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersSignupSettingsEditFieldIsCheckedByDefault = function (params) {
        return this.bi.log(__assign({ evid: 863 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsCreateEmailMarketingParams
    * @property {string} email_marketing_type - 'send a newsletter','special offer','promote business','start from scratch','explore all templates'
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Create Email marketing. Evid: 1017.
     * Event description: Form Builder - Form settings - Create Email marketing.
    
     * email_marketing_type - Type: string. Desc: 'send a newsletter','special offer','promote business','start from scratch','explore all templates'
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsCreateEmailMarketingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsCreateEmailMarketing = function (params) {
        return this.bi.log(__assign({ evid: 1017 }, params));
    };
    /**
    * @typedef {Object} formBuilderDesignPanelParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} control_name - sub panel name
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} panel_name - main panel name
    * @property {string} value - value
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Design Panel. Evid: 906.
     * Event description: user changes the design of the form.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * control_name - Type: string. Desc: sub panel name
     *
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * panel_name - Type: string. Desc: main panel name
     *
     * value - Type: string. Desc: value
     *
     * visitor_id - Type: guid.
     * @param {formBuilderDesignPanelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderDesignPanel = function (params) {
        return this.bi.log(__assign({ evid: 906 }, params));
    };
    /**
    * @typedef {Object} formBuilderTemplatePickerChooseTemplateParams
    * @property {string} appVersion - appVersion
    * @property {string} builderOrigin - ADI/Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} source_name - app market / add panel
    * @property {string} template - template selected
    * @property {GUID} visitor_id - deprecated
    **/
    /**
     * Name: Form Builder - Template picker - choose template - installed successfully. Evid: 912.
     * Event description: user clicks on choose/start after selecting a template in the form template picker OR install from add panel.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * builderOrigin - Type: string. Desc: ADI/Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * source_name - Type: string. Desc: app market / add panel
     *
     * template - Type: string. Desc: template selected
     *
     * visitor_id - Type: guid. Desc: deprecated
     * @param {formBuilderTemplatePickerChooseTemplateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderTemplatePickerChooseTemplate = function (params) {
        return this.bi.log(__assign({ evid: 912 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepAddNewStepParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - add new step. Evid: 886.
     * Event description: Form Builder - Multi Step - add new step.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepAddNewStepParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepAddNewStep = function (params) {
        return this.bi.log(__assign({ evid: 886 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormLayoutSpaceBetweenRowsParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {string} value - space between rows value
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form layout - Space between rows. Evid: 946.
     * Event description: user updated space between rows.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * value - Type: string. Desc: space between rows value
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormLayoutSpaceBetweenRowsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormLayoutSpaceBetweenRows = function (params) {
        return this.bi.log(__assign({ evid: 946 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsInboxOptInOutFindOutMoreParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - origin
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - inbox opt in/out - find out more. Evid: 1026.
     * Event description: Form Builder - Form settings - inbox opt in/out - find out more.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsInboxOptInOutFindOutMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsInboxOptInOutFindOutMore = function (params) {
        return this.bi.log(__assign({ evid: 1026 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormCopyAttemptParams
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - id of original form
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form copy attempt. Evid: 909.
     * Event description: user trying to copy a form.
    
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: id of original form
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormCopyAttemptParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormCopyAttempt = function (params) {
        return this.bi.log(__assign({ evid: 909 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListClickParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} referral - referral page
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Contact List - click. Evid: 956.
     * Event description: Form Builder - Form settings - Contact List - click.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * referral - Type: string. Desc: referral page
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsContactListClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListClick = function (params) {
        return this.bi.log(__assign({ evid: 956 }, params));
    };
    /**
    * @typedef {Object} siteMembersSignupSettingsEditFieldTextSettingsParams
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} setting_value - {}
    * @property {string} text_setting_type - { 'Bold'/ 'Italic'/ 'Underline',.......}
    * @property {GUID} visitor_id - visitor_id
    **/
    /**
     * Name: Site Members - signup settings - edit field- text settings. Evid: 864.
     * Event description: user updating field text settings.
    
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * setting_value - Type: string. Desc: {}
     *
     * text_setting_type - Type: string. Desc: { 'Bold'/ 'Italic'/ 'Underline',.......}
     *
     * visitor_id - Type: guid. Desc: visitor_id
     * @param {siteMembersSignupSettingsEditFieldTextSettingsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.siteMembersSignupSettingsEditFieldTextSettings = function (params) {
        return this.bi.log(__assign({ evid: 864 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormLayoutTextAlignmentParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {string} value - {right / center / left}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form layout - Text Alignment. Evid: 948.
     * Event description: user updated Text Alignment.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * value - Type: string. Desc: {right / center / left}
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormLayoutTextAlignmentParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormLayoutTextAlignment = function (params) {
        return this.bi.log(__assign({ evid: 948 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepClickOnManageStepsParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} click_type - 'manage steps button', 'form settings', 'steps dropdown'
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - click on Manage Steps. Evid: 883.
     * Event description: Form Builder - Multi Step - click on Manage Steps.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * click_type - Type: string. Desc: 'manage steps button', 'form settings', 'steps dropdown'
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepClickOnManageStepsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepClickOnManageSteps = function (params) {
        return this.bi.log(__assign({ evid: 883 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListContactLabelsClickParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: Form Builder - Form settings - contact list - contact labels - click. Evid: 992.
     * Event description: Form Builder - Form settings - contact list - contact labels - click.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {formBuilderFormSettingsContactListContactLabelsClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListContactLabelsClick = function (params) {
        return this.bi.log(__assign({ evid: 992 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsCreateAutomationParams
    * @property {string} automation_type - 'send a thank you email' , 'create a new task', 'send a chat message'
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Create Automation. Evid: 961.
     * Event description: Form Builder - Form settings - Create Automation.
    
     * automation_type - Type: string. Desc: 'send a thank you email' , 'create a new task', 'send a chat message'
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsCreateAutomationParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsCreateAutomation = function (params) {
        return this.bi.log(__assign({ evid: 961 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormViewPublishSitePopUpUserSelectionParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} selection - = 'dismiss' / 'question sign'/‘got it’
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form -‘View Publish Site’ pop up - user selection. Evid: 980.
     * Event description: - Payment Form -‘View Publish Site’ pop up - user selection.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * selection - Type: string. Desc: = 'dismiss' / 'question sign'/‘got it’
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormViewPublishSitePopUpUserSelectionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormViewPublishSitePopUpUserSelection = function (params) {
        return this.bi.log(__assign({ evid: 980 }, params));
    };
    /**
    * @typedef {Object} formBuilderPremiumPanelOpenedParams
    * @property {string} builderOrigin - ADI / Editor / Responsive
    * @property {string} current_ascend_plan - plan name (Basic/Pro/..)  or ‘free’
    * @property {GUID} esi - esi
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - origin
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Premium Panel Opened. Evid: 934.
     * Event description: user see upgrade panel.
    
     * builderOrigin - Type: string. Desc: ADI / Editor / Responsive
     *
     * current_ascend_plan - Type: string. Desc: plan name (Basic/Pro/..)  or ‘free’
     *
     * esi - Type: guid. Desc: esi
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: origin
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPremiumPanelOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPremiumPanelOpened = function (params) {
        return this.bi.log(__assign({ evid: 934 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSettingLearnMoreParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form Setting - Learn More. Evid: 969.
     * Event description: user click on Learn More in Payment Form settings.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSettingLearnMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSettingLearnMore = function (params) {
        return this.bi.log(__assign({ evid: 969 }, params));
    };
    /**
    * @typedef {Object} formBuilderInputPlaceholderPropertyChangedParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - input placeholder property changed. Evid: 905.
     * Event description: input placeholder property changed.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderInputPlaceholderPropertyChangedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderInputPlaceholderPropertyChanged = function (params) {
        return this.bi.log(__assign({ evid: 905 }, params));
    };
    /**
    * @typedef {Object} formBuilderAdiReorderFieldCompleteParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {GUID} esi - esi
    * @property {string} field_name - field_name
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - {'dropdown', 'edit button'}
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - ADI - Reorder Field - complete. Evid: 944.
     * Event description: Reorder Field - complete.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * esi - Type: guid. Desc: esi
     *
     * field_name - Type: string. Desc: field_name
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: {'dropdown', 'edit button'}
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderAdiReorderFieldCompleteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderAdiReorderFieldComplete = function (params) {
        return this.bi.log(__assign({ evid: 944 }, params));
    };
    /**
    * @typedef {Object} formBuilderSubmitButtonSettingsClickOnSetupPaymentFormParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {string} form_type - multistep form/ ...
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Submit Button Settings - Click on Setup payment Form. Evid: 896.
     * Event description: Form Builder - Submit Button Settings - Click on Setup payment Form.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * form_type - Type: string. Desc: multistep form/ ...
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderSubmitButtonSettingsClickOnSetupPaymentFormParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderSubmitButtonSettingsClickOnSetupPaymentForm = function (params) {
        return this.bi.log(__assign({ evid: 896 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageFieldsPanelOpenedParams
    * @property {string} builderOrigin - ADI/Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Manage fields - panel opened. Evid: 913.
     * Event description: manage form fields panel is opened.
    
     * builderOrigin - Type: string. Desc: ADI/Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageFieldsPanelOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageFieldsPanelOpened = function (params) {
        return this.bi.log(__assign({ evid: 913 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListChooseSavedFieldsClickOnDropdownFieldParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} choose - 'don't save', field name or create custom field
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - contact list - choose saved fields - click on dropdown field. Evid: 1012.
     * Event description: Form Builder - Form settings - contact list - choose saved fields - click on dropdown field.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * choose - Type: string. Desc: 'don't save', field name or create custom field
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsContactListChooseSavedFieldsClickOnDropdownFieldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListChooseSavedFieldsClickOnDropdownField = function (params) {
        return this.bi.log(__assign({ evid: 1012 }, params));
    };
    /**
    * @typedef {Object} formBuilderEditFieldUpdateValueParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} name - placeholder, field name
    * @property {string} origin - 'field settings','gfpp'
    * @property {string} plugin - plugin
    * @property {boolean} toggle_state - toggle state
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Edit field - update value. Evid: 918.
     * Event description: user updated a value (e.g placeholder text, field name).
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * name - Type: string. Desc: placeholder, field name
     *
     * origin - Type: string. Desc: 'field settings','gfpp'
     *
     * plugin - Type: string. Desc: plugin
     *
     * toggle_state - Type: bool. Desc: toggle state
     *
     * visitor_id - Type: guid.
     * @param {formBuilderEditFieldUpdateValueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderEditFieldUpdateValue = function (params) {
        return this.bi.log(__assign({ evid: 918 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsInboxOptInOutUpdateEmailParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - inbox opt in/out - update email. Evid: 1023.
     * Event description: Form Builder - Form settings - update email.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsInboxOptInOutUpdateEmailParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsInboxOptInOutUpdateEmail = function (params) {
        return this.bi.log(__assign({ evid: 1023 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsCreateSubmissionsTableRequestParams
    * @property {string} appVersion - appVersion
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - 'main tab' , 'settings tab'
    * @property {string} request_type - {manual (user click), auto (from template}
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - create submissions table - request. Evid: 928.
     * Event description: request to create a submissions table was sent either by user clicking on create submissions table inside forms settings panel
    or choose a template with a submission table.
    
     * appVersion - Type: string. Desc: appVersion
     *
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: 'main tab' , 'settings tab'
     *
     * request_type - Type: string. Desc: {manual (user click), auto (from template}
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsCreateSubmissionsTableRequestParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsCreateSubmissionsTableRequest = function (params) {
        return this.bi.log(__assign({ evid: 928 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormAddNewRuleParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - add new rule. Evid: 1096.
     * Event description: Form Builder - conditional form - add new rule.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormAddNewRuleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormAddNewRule = function (params) {
        return this.bi.log(__assign({ evid: 1096 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSubscriberDoubleOptInLearnMoreParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Subscriber double opt in - learn more. Evid: 1019.
     * Event description: Form Builder - Form settings - Subscriber double opt in - learn more.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSubscriberDoubleOptInLearnMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSubscriberDoubleOptInLearnMore = function (params) {
        return this.bi.log(__assign({ evid: 1019 }, params));
    };
    /**
    * @typedef {Object} formBuilderMultiStepBackNextButtonChangeTextParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} button - next/back
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Multi Step - back/next button - change text. Evid: 890.
     * Event description: Form Builder - Multi Step - back/next button - change text.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * button - Type: string. Desc: next/back
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderMultiStepBackNextButtonChangeTextParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderMultiStepBackNextButtonChangeText = function (params) {
        return this.bi.log(__assign({ evid: 890 }, params));
    };
    /**
    * @typedef {Object} formBuilderEditorXAddASubscribeCheckboxParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form comp id
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Editor X - add a subscribe checkbox. Evid: 1094.
     * Event description: Form Builder - Editor X - add a subscribe checkbox.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form comp id
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderEditorXAddASubscribeCheckboxParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderEditorXAddASubscribeCheckbox = function (params) {
        return this.bi.log(__assign({ evid: 1094 }, params));
    };
    /**
    * @typedef {Object} formBuildrUouSubmitFormSuccessSendingDataToFormBuilderServerParams
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {string} form_name - the form name, given by user
    * @property {string} form_url - form specific url
    * @property {GUID} msid - msid
    * @property {number} num_of_attachments - number of attachments, 0 if none
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Buildr - UoU submit form - success sending data to wix code server. Evid: 904.
     * Event description: UoU clicked on submit in a form created with the form builder - success sending data to wix code server.
    
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * form_name - Type: string. Desc: the form name, given by user
     *
     * form_url - Type: string. Desc: form specific url
     *
     * msid - Type: guid. Desc: msid
     *
     * num_of_attachments - Type: numeric. Desc: number of attachments, 0 if none
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuildrUouSubmitFormSuccessSendingDataToFormBuilderServerParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuildrUouSubmitFormSuccessSendingDataToFormBuilderServer = function (params) {
        return this.bi.log(__assign({ evid: 904 }, params));
    };
    /**
    * @typedef {Object} formBuilderManageChoicesSetAsDefaultChoiceParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} choice_name - choice_name
    * @property {GUID} esi - esi
    * @property {string} field_type - field_type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder -  Manage Choices - set as default choice. Evid: 876.
     * Event description: user click on remove default/set as default choice.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * choice_name - Type: string. Desc: choice_name
     *
     * esi - Type: guid. Desc: esi
     *
     * field_type - Type: string. Desc: field_type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderManageChoicesSetAsDefaultChoiceParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderManageChoicesSetAsDefaultChoice = function (params) {
        return this.bi.log(__assign({ evid: 876 }, params));
    };
    /**
    * @typedef {Object} formBuilderTemplatePickerClickOnTemplateParams
    * @property {GUID} msid - msid
    * @property {string} template - template selected
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Template picker - click on template. Evid: 911.
     * Event description: user clicks on a template in the form template picker.
    
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template selected
     *
     * visitor_id - Type: guid.
     * @param {formBuilderTemplatePickerClickOnTemplateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderTemplatePickerClickOnTemplate = function (params) {
        return this.bi.log(__assign({ evid: 911 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsInformationIconHoverClickParams
    * @property {string} information_icon - 'contact labels' , 'submit message'
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - information icon - hover/click. Evid: 962.
     * Event description: Form Builder - Form settings - information icon - hover/click.
    
     * information_icon - Type: string. Desc: 'contact labels' , 'submit message'
     *
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsInformationIconHoverClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsInformationIconHoverClick = function (params) {
        return this.bi.log(__assign({ evid: 962 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSaveAndRefreshPopUpDisplayedParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form - 'save and refresh' pop up displayed. Evid: 977.
     * Event description: Payment Form - 'save and refresh' pop up displayed.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSaveAndRefreshPopUpDisplayedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSaveAndRefreshPopUpDisplayed = function (params) {
        return this.bi.log(__assign({ evid: 977 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormTooltipHoverParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} origin - ='payment page in form settings' / 'add item step in payment form setup'
    * @property {string} tooltip_name - 'item price'
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form - tooltip hover. Evid: 985.
     * Event description: user hover on an information icon.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: ='payment page in form settings' / 'add item step in payment form setup'
     *
     * tooltip_name - Type: string. Desc: 'item price'
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormTooltipHoverParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormTooltipHover = function (params) {
        return this.bi.log(__assign({ evid: 985 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormClickOnGoToSetupParams
    * @property {string} builderOrigin - ADI  /  Editor
    * @property {string} category - 'Contact' / 'Payment Form' / 'Job Application' / etc...
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form - click on Go to Setup. Evid: 988.
     * Event description: when user clicks on "Go to Setup" from notification that appears when adding a payment form preset.
    
     * builderOrigin - Type: string. Desc: ADI  /  Editor
     *
     * category - Type: string. Desc: 'Contact' / 'Payment Form' / 'Job Application' / etc...
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormClickOnGoToSetupParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormClickOnGoToSetup = function (params) {
        return this.bi.log(__assign({ evid: 988 }, params));
    };
    /**
    * @typedef {Object} formBuilderConditionalFormSaveRuleParams
    * @property {string} builderOrigin - ADI, Editor
    * @property {string} form_comp_id - form_comp_id
    * @property {GUID} msid - msid
    * @property {string} template - template
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - conditional form - save rule. Evid: 1106.
     * Event description: Form Builder - conditional form - save rule.
    
     * builderOrigin - Type: string. Desc: ADI, Editor
     *
     * form_comp_id - Type: string. Desc: form_comp_id
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template
     *
     * visitor_id - Type: guid.
     * @param {formBuilderConditionalFormSaveRuleParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderConditionalFormSaveRule = function (params) {
        return this.bi.log(__assign({ evid: 1106 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListChooseSavedFieldsHoverYourFormFieldsParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - contact list - choose saved fields - hover your form fields. Evid: 1010.
     * Event description: Copy of Form Builder - Form settings - contact list - choose saved fields - hover your form fields.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsContactListChooseSavedFieldsHoverYourFormFieldsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListChooseSavedFieldsHoverYourFormFields = function (params) {
        return this.bi.log(__assign({ evid: 1010 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsSubmitMessageRestoreSubmitButtonParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Form settings - Submit Message - Restore Submit Button. Evid: 967.
     * Event description: Submit Message - Restore Submit Button - not in use!.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid.
     * @param {formBuilderFormSettingsSubmitMessageRestoreSubmitButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsSubmitMessageRestoreSubmitButton = function (params) {
        return this.bi.log(__assign({ evid: 967 }, params));
    };
    /**
    * @typedef {Object} formBuilderFormSettingsContactListChooseSavedFieldsSaveParams
    * @property {string} builderOrigin - ADI/ Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {string} template - template name
    * @property {GUID} visitor_id - visitor id
    **/
    /**
     * Name: Form Builder - Form settings - contact list - choose saved fields - save. Evid: 996.
     * Event description: Form Builder - Form settings - contact list - choose saved fields - update value.
    
     * builderOrigin - Type: string. Desc: ADI/ Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * template - Type: string. Desc: template name
     *
     * visitor_id - Type: guid. Desc: visitor id
     * @param {formBuilderFormSettingsContactListChooseSavedFieldsSaveParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderFormSettingsContactListChooseSavedFieldsSave = function (params) {
        return this.bi.log(__assign({ evid: 996 }, params));
    };
    /**
    * @typedef {Object} formBuilderPaymentFormSetupContinueToSetupFromBizmgParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Payment Form Setup - Continue to setup from BizMG. Evid: 975.
     * Event description: Payment Form Setup - Continue to setup from BizMG.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderPaymentFormSetupContinueToSetupFromBizmgParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderPaymentFormSetupContinueToSetupFromBizmg = function (params) {
        return this.bi.log(__assign({ evid: 975 }, params));
    };
    /**
    * @typedef {Object} formBuilderEditFieldUpdateMandatoryValueParams
    * @property {string} builderOrigin - ADI / Editor
    * @property {string} field_name - field name
    * @property {string} field_type - field type
    * @property {string} form_comp_id - form unique id (per msid)
    * @property {boolean} is_required - true if set to required
    * @property {GUID} msid - msid
    * @property {string} origin - type of checkbox required / checked by default
    * @property {string} plugin - form type = {'form-builder'/'get-subscribers'/'registration-form'}
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Edit field - update mandatory value. Evid: 919.
     * Event description: user selects/deselects if field is required or not.
    
     * builderOrigin - Type: string. Desc: ADI / Editor
     *
     * field_name - Type: string. Desc: field name
     *
     * field_type - Type: string. Desc: field type
     *
     * form_comp_id - Type: string. Desc: form unique id (per msid)
     *
     * is_required - Type: bool. Desc: true if set to required
     *
     * msid - Type: guid. Desc: msid
     *
     * origin - Type: string. Desc: type of checkbox required / checked by default
     *
     * plugin - Type: string. Desc: form type = {'form-builder'/'get-subscribers'/'registration-form'}
     *
     * visitor_id - Type: guid.
     * @param {formBuilderEditFieldUpdateMandatoryValueParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderEditFieldUpdateMandatoryValue = function (params) {
        return this.bi.log(__assign({ evid: 919 }, params));
    };
    /**
    * @typedef {Object} formBuilderTemplatePickerOpenedParams
    * @property {GUID} msid - msid
    * @property {GUID} visitor_id - null
    **/
    /**
     * Name: Form Builder - Template picker opened. Evid: 910.
     * Event description: form template picker is opened.
    
     * msid - Type: guid. Desc: msid
     *
     * visitor_id - Type: guid.
     * @param {formBuilderTemplatePickerOpenedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.formBuilderTemplatePickerOpened = function (params) {
        return this.bi.log(__assign({ evid: 910 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
function getLoggerConf() {
    return {
        src: 5,
        endpoint: 'form-builder'
    };
}
exports.getLoggerConf = getLoggerConf;
//# sourceMappingURL=index.js.map